import { countryConfig } from '../country';

/**
 * The Spanish-language editions — MiLicita (`es`, Spain) and Liciora (`cl`,
 * Chile) — run the same product: the same funnel, paywall, pages, Stripe
 * checkout and consent banner, with Spanish copy. A switch that is about THAT
 * product («the Spanish edition shows no popularity ribbon», «percentages are
 * written `88,8 %`») reads this; a switch about a fact of Spain (PLACSP, the
 * NIF, euros, Madrid, the LCSP guide) keeps reading `code === 'es'` and gives
 * Chile its own value — or nothing.
 */
export function isHispanicEdition(code: string = countryConfig.code): boolean {
  return code === 'es' || code === 'cl';
}

/** {@link isHispanicEdition} for the active build, resolved at module load. */
export const HISPANIC_EDITION = isHispanicEdition();

/** Liciora (Chile) — for the few Chilean facts the Spanish edition does not have. */
export const CHILE_EDITION = countryConfig.code === 'cl';
